export default __webpack_public_path__ + "static/expedition-f864612283894879dd0746e1da4ca4f9.png";